var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2595_140756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3036 7.77863L13.4922 5.75009L11.6563 5.75398L11.6445 4.25008L13.6606 4.25009C13.9105 4.24906 14.1549 4.32334 14.362 4.46327C14.5693 4.60336 14.7296 4.80271 14.8218 5.03528L15.6963 7.22154C15.8502 7.60613 15.6631 8.04261 15.2785 8.19644C14.8939 8.35028 14.4574 8.16322 14.3036 7.77863Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 9.00009C0.25 8.58588 0.585786 8.25009 1 8.25009H11C11.4142 8.25009 11.75 8.58588 11.75 9.00009C11.75 9.41431 11.4142 9.75009 11 9.75009H1C0.585786 9.75009 0.25 9.41431 0.25 9.00009Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 11.2501C10.8358 11.2501 10.5 11.5859 10.5 12.0001C10.5 12.4143 10.8358 12.7501 11.25 12.7501C11.6642 12.7501 12 12.4143 12 12.0001C12 11.5859 11.6642 11.2501 11.25 11.2501ZM9 12.0001C9 10.7575 10.0074 9.75009 11.25 9.75009C12.4926 9.75009 13.5 10.7575 13.5 12.0001C13.5 13.2427 12.4926 14.2501 11.25 14.2501C10.0074 14.2501 9 13.2427 9 12.0001Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 11.2501C4.33579 11.2501 4 11.5859 4 12.0001C4 12.4143 4.33579 12.7501 4.75 12.7501C5.16421 12.7501 5.5 12.4143 5.5 12.0001C5.5 11.5859 5.16421 11.2501 4.75 11.2501ZM2.5 12.0001C2.5 10.7575 3.50736 9.75009 4.75 9.75009C5.99264 9.75009 7 10.7575 7 12.0001C7 13.2427 5.99264 14.2501 4.75 14.2501C3.50736 14.2501 2.5 13.2427 2.5 12.0001Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 12.0001C5.5 11.5859 5.83579 11.2501 6.25 11.2501H9.75C10.1642 11.2501 10.5 11.5859 10.5 12.0001C10.5 12.4143 10.1642 12.7501 9.75 12.7501H6.25C5.83579 12.7501 5.5 12.4143 5.5 12.0001Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 4.75009V11.2501H3.25C3.66421 11.2501 4 11.5859 4 12.0001C4 12.4143 3.66421 12.7501 3.25 12.7501H1.5C1.16848 12.7501 0.850538 12.6184 0.616116 12.384C0.381696 12.1496 0.25 11.8316 0.25 11.5001V4.50009C0.25 4.16857 0.381696 3.85063 0.616116 3.61621C0.850537 3.38179 1.16848 3.25009 1.5 3.25009H11C11.4142 3.25009 11.75 3.58588 11.75 4.00009V10.5188C11.75 10.9331 11.4142 11.2688 11 11.2688C10.5858 11.2688 10.25 10.9331 10.25 10.5188V4.75009H1.75Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 7.50009C10.25 7.08588 10.5858 6.75009 11 6.75009H15C15.4142 6.75009 15.75 7.08588 15.75 7.50009V11.5001C15.75 11.8316 15.6183 12.1496 15.3839 12.384C15.1495 12.6184 14.8315 12.7501 14.5 12.7501H12.75C12.3358 12.7501 12 12.4143 12 12.0001C12 11.5859 12.3358 11.2501 12.75 11.2501H14.25V8.25009H11C10.5858 8.25009 10.25 7.91431 10.25 7.50009Z",
    fill: "black",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2595_140756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/Truck.8bc7646e.svg";
export { ForwardRef as ReactComponent };